(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/result/assets/javascripts/views/result.js') >= 0) return;  svs.modules.push('/modules/keno/components/result/assets/javascripts/views/result.js');

'use strict';

svs.keno.components.result.views.Result = Marionette.View.extend({
  viewOptions: ['selectedDate'],
  selectedDate: undefined,
  className: 'numbergames-content',
  regions: {
    datePickerRegion: '#datePickerRegion',
    campaignRegion: '#campaignRegion',
    resultRowRegion: '#resultRowRegion',
    peppbubblesRegion: '#peppbubblesRegion',
    payoutRegion: '#payoutRegion'
  },
  modelEvents: {
    'results:change:draw': 'renderResult'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.results.behaviors.BindResultModel,
    resultData: svs.keno.data.resultData,
    product: svs.numbergames.productMapping.CONSTANTS.KENO
  }],
  template(data) {
    return svs.keno.components.result.templates.result(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    this.showChildView('datePickerRegion', new svs.numbergames.results.views.DatePicker({
      model: this.model
    }));
    this.showChildView('campaignRegion', new svs.numbergames.results.views.Campaign({
      model: this.model
    }));
    const draw = this.model.get('resultMonths').getDrawByDate(this.model.get('selectedDate'));
    const resultModel = draw ? this.model.get('results').getResultByDraw(draw) : this.model.get('results').first();
    if (resultModel) {
      this.renderResult(resultModel);
    }
  },
  renderResult(model) {
    this.showChildView('resultRowRegion', new svs.numbergames.results.views.CorrectRow({
      model
    }));
    this.showChildView('peppbubblesRegion', new svs.numbergames.results.views.Peppbubbles({
      model
    }));
    this.showChildView('payoutRegion', new svs.numbergames.results.views.PayoutTables({
      model
    }));
  }
});

 })(window);